// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teamsContainer_dwO19 {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: scroll;
  &::-webkit-scrollbar{
    display: none;
  }
}
.team_qISKj {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding: 20px 0;

  .imgContainer_jfYQx {
    position: relative;
    height: 50px;
    .statusIndicator_evP32 {
      position: absolute;
      bottom: 0;
      right: 0;
      height: 15px;
      width: 15px;
    }
  }
  img {
    width: 50px;
    height: 50px;
  }
  .contentTeam_Px83G {
    width: 100%;
  }
  .headerTeam_fXm8X {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .headerTeamLeft_PSuCs {
      display: flex;
      flex: 1 1;
      gap: 10px;
      align-items: center;
      width: 100%;
      justify-content: space-between;
    }
    .headerTeamRight_Gsrew {
      color: var(--_6-color);
      text-align: right;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
  .teamDesc__6fLw {
    display: flex;
    gap: 10px;
    p {
      margin: 0;
      color: var(--_6-color);
      font-family: Roboto;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 
      span {
        color: var(--Light-MineShaftFontColor, #484848);
        text-align: center;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
  }
  .statusIndicator_evP32 {
    width: 10px;
    height: 10px;
    border-radius: 999px;
    -webkit-border-radius: 999px;
    -moz-border-radius: 999px;
    -ms-border-radius: 999px;
    -o-border-radius: 999px;
  }
}

.btnOptionsContainer_DE5Oa {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: end;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DashboardComponents/TeamListSimple/TeamListSimple.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,4CAA4C;EAC5C,eAAe;;EAEf;IACE,kBAAkB;IAClB,YAAY;IACZ;MACE,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,YAAY;MACZ,WAAW;IACb;EACF;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX;MACE,aAAa;MACb,SAAO;MACP,SAAS;MACT,mBAAmB;MACnB,WAAW;MACX,8BAA8B;IAChC;IACA;MACE,sBAAsB;MACtB,iBAAiB;MACjB,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;EACF;EACA;IACE,aAAa;IACb,SAAS;IACT;MACE,SAAS;MACT,sBAAsB;MACtB,mBAAmB;MACnB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB;QACE,+CAA+C;QAC/C,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;MACrB;IACF;EACF;EACA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,SAAS;AACX","sourcesContent":[".teamsContainer {\n  display: flex;\n  flex-direction: column;\n  max-height: 80vh;\n  overflow-y: scroll;\n  &::-webkit-scrollbar{\n    display: none;\n  }\n}\n.team {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  padding: 20px 0;\n\n  .imgContainer {\n    position: relative;\n    height: 50px;\n    .statusIndicator {\n      position: absolute;\n      bottom: 0;\n      right: 0;\n      height: 15px;\n      width: 15px;\n    }\n  }\n  img {\n    width: 50px;\n    height: 50px;\n  }\n  .contentTeam {\n    width: 100%;\n  }\n  .headerTeam {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    .headerTeamLeft {\n      display: flex;\n      flex: 1;\n      gap: 10px;\n      align-items: center;\n      width: 100%;\n      justify-content: space-between;\n    }\n    .headerTeamRight {\n      color: var(--_6-color);\n      text-align: right;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n  .teamDesc {\n    display: flex;\n    gap: 10px;\n    p {\n      margin: 0;\n      color: var(--_6-color);\n      font-family: Roboto;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px; \n      span {\n        color: var(--Light-MineShaftFontColor, #484848);\n        text-align: center;\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n      }\n    }\n  }\n  .statusIndicator {\n    width: 10px;\n    height: 10px;\n    border-radius: 999px;\n    -webkit-border-radius: 999px;\n    -moz-border-radius: 999px;\n    -ms-border-radius: 999px;\n    -o-border-radius: 999px;\n  }\n}\n\n.btnOptionsContainer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: end;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamsContainer": `teamsContainer_dwO19`,
	"team": `team_qISKj`,
	"imgContainer": `imgContainer_jfYQx`,
	"statusIndicator": `statusIndicator_evP32`,
	"contentTeam": `contentTeam_Px83G`,
	"headerTeam": `headerTeam_fXm8X`,
	"headerTeamLeft": `headerTeamLeft_PSuCs`,
	"headerTeamRight": `headerTeamRight_Gsrew`,
	"teamDesc": `teamDesc__6fLw`,
	"btnOptionsContainer": `btnOptionsContainer_DE5Oa`
};
export default ___CSS_LOADER_EXPORT___;
